var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6654 13.0499L12.3976 22.5C11.5487 22.5 10.7346 22.1681 10.1343 21.5774C9.53407 20.9866 9.19685 20.1854 9.19685 19.35L9.19685 15.1499L3.15802 15.1499C2.84871 15.1533 2.54234 15.0906 2.26013 14.9659C1.97792 14.8413 1.72662 14.6577 1.52364 14.428C1.32066 14.1983 1.17086 13.9279 1.08462 13.6355C0.998373 13.3431 0.977746 13.0358 1.02417 12.7349L2.49653 3.28471C2.57369 2.78395 2.83215 2.32751 3.22428 1.99949C3.6164 1.67146 4.11578 1.49396 4.63039 1.49968L16.6654 1.49969M16.6654 13.0499L16.6654 1.49969M16.6654 13.0499L19.8661 13.0499C20.4321 13.0499 20.9748 12.8286 21.375 12.4348C21.7752 12.0409 22 11.5068 22 10.9498L22 3.59972C22 3.04275 21.7752 2.5086 21.375 2.11477C20.9748 1.72094 20.4321 1.49969 19.8661 1.49969L16.6654 1.49969",
    stroke: "#D93839",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb-down.8b2e3673534ee0b120e9a9db0c119a8f.svg";
export { ForwardRef as ReactComponent };